import 'assets/css/modal.css';
import 'styles/custom.css';
import * as React from 'react';
import {getCurrentCustodianVersion, ResetAPIKey, CopyAPIKey, getCurrentEnvironments, getTargetEnvironments} from "../components/Requests/Requests";
import {
  StandardScreen,
  StandardSearchBox, 
  StandardDropdown, 
  StandardButton, 
  StatusMessage,
  PageLayout,
  StandardText,
} from '../components/Layout';

class APIReset extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            loading: false,
            error:"",
            currentCustodianVersion: "",
            spHostUrl: "", 
            message: "",
            resetMessage: "",
            resetError: "",
            copyMessage: "",
            copyError: "",
            currentEnvironments:"",
            currentEnvironmentChosen: "",
            targetEnvironments:"",
            targetEnvironmentChosen: "",
            sourceEnvironmentChosen:""
        }
    }

    async getCurrentEnvironments(spHostUrl) {
        this.setState({ loading: true })
        let response = await getCurrentEnvironments(this.props.accessToken, spHostUrl);
        let data = await response.json();
        if (response.status === 200) {
            if (data.length > 0) {
                this.getTargetEnvironments(data);
            }
            this.setState({
                loading: false,
                currentEnvironments: data.map((item) => { return { key: item.webAppUrl, text: item.apiKeyDbName, isActive: item.isActive } }),
                message: data.length > 0 ? "" : "No API Key found for " + spHostUrl,
                currentEnvironmentChosen: null,
                error: ""
            })
        } else {
            this.setState({ loading: false, error: data.Message });
        }
    }

    async getTargetEnvironments(currentEnvironments) {
        this.setState({ loading: true })
        let response = await getTargetEnvironments(this.props.accessToken, currentEnvironments);
        let data = await response.json();
        if (response.status === 200) {
            data = data.filter((item) => {
                return !currentEnvironments.some((currentEnvironment) => currentEnvironment.webAppUrl === item.webAppUrl)
            });
            this.setState({
                loading: false,
                targetEnvironments: data.map((item) => { return { key: item.webAppUrl, text: item.apiKeyDbName } }),
                targetEnvironmentChosen: null,
                sourceEnvironmentChosen: null,
                error: ""
            })
        }
    }

    async resetAPIKey(spHostUrl, environmentUrl) {
        this.setState({ loading: true })
        let response = await ResetAPIKey(this.props.accessToken, spHostUrl, environmentUrl);
        let data = await response.json();
        if (response.status === 200) {
            this.setState({
                loading: false,
                resetMessage: data ? "API Key reset successfully" : "No key found, you should be able to create an API key via custodian",
                resetError: ""
            })
        } else {
            this.setState({ loading: false, resetError: data.Message, resetMessage: "" });
        }
    }

    async getCurrentCustodianVersion(spHostUrl) {
        this.setState({ loading: true })
        let response = await getCurrentCustodianVersion(this.props.accessToken, spHostUrl);
        let data = await response.json();
        if (response.status === 200) {
            this.setState({ loading: false, currentCustodianVersion: data.custodianUrl, error: "" })
        } else {
            this.setState({ loading: false, error: data.Message });
        }
    }

    async copyAPIKey(spHostUrl, currentEnvironmentChosen, targetEnvironmentChosen) {
        this.setState({ loading: true })
        let response = await CopyAPIKey(this.props.accessToken, spHostUrl, currentEnvironmentChosen, targetEnvironmentChosen);
        let data = await response.json();
        if (response.status === 200) {
            this.setState({
                loading: false,
                copyMessage: data !== "" ? (data) : "No key found, you should be able to create an API key via custodian",
                copyError: ""
            })
        } else {
            this.setState({ loading: false, copyError: data.Message, copyMessage: "" });
        }
    }

    onSelectCurrentEnvironment = (event, item) => {
        this.setState({ 
            currentEnvironmentChosen: item.key,
            resetMessage: "",
            resetError: ""
        });    
    };

    onSelectTargetEnvironment = (event, item) => {
        this.setState({ 
            targetEnvironmentChosen: item.key,
            copyMessage: "",
            copyError: ""
        });    
    };

    onSelectSourceEnvironment = (event, item) => {
        this.setState({ 
            sourceEnvironmentChosen: item.key,
            copyMessage: "",
            copyError: ""
        });    
    };

    onSpHostUrlChange = (newValue) => {
        this.setState({ 
            spHostUrl: newValue,
            message: "",
            error: "",
            resetMessage: "",
            resetError: "",
            copyMessage: "",
            copyError: "",
            currentEnvironments: "",
            currentEnvironmentChosen: "",
            targetEnvironments: "",
            targetEnvironmentChosen: "",
            sourceEnvironmentChosen: ""
        });
    };

    render() {
        const {
            loading,
            error,
            message,
            resetMessage,
            resetError,
            copyMessage,
            copyError,
            spHostUrl,
            currentEnvironments,
            currentEnvironmentChosen,
            targetEnvironments,
            targetEnvironmentChosen,
            sourceEnvironmentChosen
        } = this.state;

        return (
            <PageLayout>
                <StandardScreen
                    title="API Key Search"
                    description="Enter the SP Host URL of the site you wish to search API Keys for."
                    loading={loading}
                >
                    <StandardSearchBox
                        label="SPHostUrl"
                        placeholder="SPHostUrl"
                        value={spHostUrl}
                        onChange={this.onSpHostUrlChange}
                    />

                    <StandardButton
                        text="Search"
                        onClick={() => this.getCurrentEnvironments(spHostUrl)}
                        disabled={spHostUrl.length === 0}
                    />

                    {error && (
                        <StatusMessage type="error">{error}</StatusMessage>
                    )}

                    {currentEnvironments === null && spHostUrl && (
                        <StatusMessage type="warning">
                            No API keys found for <strong>{spHostUrl}</strong>
                        </StatusMessage>
                    )}

                    {message && (
                        <StatusMessage type="warning">{message}</StatusMessage>
                    )}
                    
                    {currentEnvironments && currentEnvironments.length > 0 && (
                      currentEnvironments.map((env) => (
                        <StatusMessage key={env.key} type={env.isActive ? "success" : "warning"}>
                          API key found in <strong>{env.text}</strong> - {env.isActive ? "Active" : "Inactive"}
                        </StatusMessage>
                      ))
                    )}
                </StandardScreen>

                {currentEnvironments && currentEnvironments.length > 0 && (
                    <StandardScreen
                        title="Reset API Key"
                        description="Select an environment to reset the API key for."
                        loading={loading}
                    >
                        <StandardDropdown
                            label="Reset API Key For"
                            selectedKey={currentEnvironmentChosen}
                            onChange={this.onSelectCurrentEnvironment}
                            placeholder="Select Environment"
                            options={currentEnvironments}
                            disabled={spHostUrl.length === 0}
                        />

                        <StandardButton
                            text="Reset"
                            onClick={() => this.resetAPIKey(spHostUrl, currentEnvironmentChosen)}
                            disabled={!currentEnvironmentChosen || spHostUrl.length === 0}
                        />

                        {resetError && (
                            <StatusMessage type="error">{resetError}</StatusMessage>
                        )}

                        {resetMessage && (
                            <StatusMessage type="success">{resetMessage}</StatusMessage>
                        )}
                    </StandardScreen>
                )}

                {currentEnvironments && currentEnvironments.length > 0 && targetEnvironments && (
                    <StandardScreen
                        title="Copy API Key"
                        description="Select source and target environments to copy API keys between."
                        loading={loading}
                    >
                         <StandardDropdown
                                label="Copy API Key From"
                                selectedKey={sourceEnvironmentChosen}
                                onChange={this.onSelectSourceEnvironment}
                                placeholder="Select Environment"
                                options={currentEnvironments}
                                disabled={spHostUrl.length === 0}
                            />

                        <StandardDropdown
                            label="Copy API Key To"
                            selectedKey={targetEnvironmentChosen}
                            onChange={this.onSelectTargetEnvironment}
                            placeholder="Select Environment"
                            options={targetEnvironments}
                            disabled={spHostUrl.length === 0}
                        />

                        <StandardButton
                            text="Copy"
                            onClick={() => this.copyAPIKey(spHostUrl, sourceEnvironmentChosen, targetEnvironmentChosen)}
                            disabled={(!targetEnvironmentChosen || !sourceEnvironmentChosen) || spHostUrl.length === 0}
                        />
                            

                        {copyError && (
                            <StatusMessage type="error">{copyError}</StatusMessage>
                        )}

                        {copyMessage && (
                            <StatusMessage type="success">{copyMessage}</StatusMessage>
                        )}
                    </StandardScreen>
                )}
            </PageLayout>
        );
    }
}

export default APIReset;
